export const PAGE_TITLE_SUFFIX = "｜DMM TV";

export const CAMPAIGN_TEXT =
  "【初回30日間無料＋550ptプレゼント】アニメ・エンタメ充実のラインナップ！新作アニメに加えてDMM TVでしか観られない独占・オリジナル作品も見放題！";
export const PAGE_DESCRIPTION_SUFFIX = `DMM TVなら${CAMPAIGN_TEXT}`;

export const OGP_IMAGE = {
  url: "https://imgsrc.dmm.com/dig/dmmtv/etc/ogp/dmmtvOgp.jpg",
  width: 1200,
  height: 630,
};

export const COPY_RIGHT = `Copyright © since 1998 DMM All Rights Reserved.`;

export const DEFAULT_TITLE = "DMM TV｜月額550円でアニメ・エンタメ見放題";
